import { SVGProps } from 'react';
const CanCrimCheckSVG = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width='75'
		zoomAndPan='magnify'
		viewBox='0 0 240 239.999995'
		height='75'
		preserveAspectRatio='xMidYMid meet'
		version='1.0'
		{...props}
	>
		<defs>
			<clipPath id='c23c757f24'>
				<path
					d='M 9.164062 0 L 231 0 L 231 240 L 9.164062 240 Z M 9.164062 0 '
					clipRule='nonzero'
				/>
			</clipPath>
		</defs>
		<g clipPath='url(#c23c757f24)'>
			<path
				className='canadian-crim-check'
				fill='#a6a6a6'
				d='M 119.960938 0.015625 L 100.609375 36.214844 C 98.414062 40.148438 94.480469 39.785156 90.546875 37.585938 L 76.53125 30.308594 L 86.976562 85.90625 C 89.175781 96.066406 82.128906 96.066406 78.652344 91.675781 L 54.199219 64.230469 L 50.230469 78.167969 C 49.773438 80 47.757812 81.921875 44.738281 81.460938 L 13.820312 74.945312 L 21.941406 104.554688 C 23.679688 111.140625 25.035156 113.871094 20.1875 115.609375 L 9.164062 120.804688 L 62.390625 164.160156 C 64.5 165.796875 65.5625 168.75 64.8125 171.417969 L 60.15625 186.75 L 113.238281 180.621094 C 114.867188 180.601562 115.929688 181.507812 115.917969 183.382812 L 112.652344 240.035156 L 127.289062 240.035156 L 124.019531 183.382812 C 124.007812 181.507812 125.074219 180.597656 126.703125 180.621094 L 179.78125 186.75 L 175.125 171.417969 C 174.375 168.75 175.4375 165.796875 177.546875 164.160156 L 230.773438 120.804688 L 219.75 115.609375 C 214.902344 113.871094 216.257812 111.140625 217.996094 104.554688 L 226.117188 74.945312 L 195.199219 81.460938 C 192.179688 81.921875 190.164062 80 189.707031 78.167969 L 185.738281 64.230469 L 161.285156 91.679688 C 157.808594 96.070312 150.761719 96.070312 152.960938 85.910156 L 163.402344 30.3125 L 149.390625 37.589844 C 145.453125 39.789062 141.523438 40.152344 139.324219 36.21875 L 119.980469 0.0234375 Z M 119.960938 0.015625 '
				fillOpacity='1'
				fillRule='nonzero'
			/>
		</g>
	</svg>
);

export default CanCrimCheckSVG;
